module.exports = __webpack_public_path__ + "static/img/4.bb5d6da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/4.png
// module id = 30eK
// module chunks = 0